import '../styles/white-border.css'

export default function WhiteBorderBtn({ width='90',text='Sign in',type = ''}) {

  if(type === 'faq'){
    
  }

  return (
    <a href='/' className='white-btn' style={{width:`${width}px`}}>{text}</a>
  )
}
